import { Viewer } from "@nova/constants"
import { Drone } from "@nova/schemas"
import { Builder } from "."
import { SocketSlice } from "./types"
import {
    addDroneToProject,
    addViewerToProject,
    removeDroneFromProject,
    removeViewerFromProject,
} from "features/entity-caching/fires/slice"
import { createFire, initializeFires } from "features/entity-caching/fires/thunks"
import { selectAllFires } from "features/entity-caching/fires/selectors"
import { createAction } from "@reduxjs/toolkit"

export const clearPubsubSocketsProjectState = createAction("clearPubsubSocketsProjectState")

export default {
    handlers: (builder: Builder) =>
        builder
            .addCase(initializeFires.fulfilled, (_, action, socket) => {
                const items = action.payload
                items.forEach((item: { id: string }) => {
                    socket.emit("subscribe", item.id, "fire")
                })
            })
            .addCase(clearPubsubSocketsProjectState, (store, __, socket) => {
                if ("projectId" in (socket.auth || {})) {
                    socket.auth = {}
                    socket.disconnect()
                    socket.once("connected", () => {
                        const fires = Object.keys(selectAllFires(store.getState()))
                        fires.forEach((id) => socket.emit("subscribe", id, "fire"))
                    })
                    socket.connect()
                }
            })
            .addCase(createFire.fulfilled, (_, action, socket) => {
                socket.emit("subscribe", action.payload.id, "fire")
            }),
    events: {
        fire: (store) => (id: string, user: Viewer) => {
            store.dispatch(addViewerToProject({ user, id }))
        },
        leavefire: (store) => (id: string, user: Viewer) => {
            store.dispatch(removeViewerFromProject({ user, id }))
        },
        firedrone: (store) => (id: string, drone: Drone) => {
            store.dispatch(addDroneToProject({ drone, id }))
        },
        firedronedisconnected: (store) => (id: string, drone: Pick<Drone, "flightId">) => {
            store.dispatch(removeDroneFromProject({ flightId: drone.flightId, id }))
        },
    },
} as SocketSlice
